<template lang="pug">
  SubmitButton(
    :loading="loading"
    icon="fa fa-file-excel"
    :text="$t('ui.' + btnTxt)"
    type="button"
    @click="tableToExcel()"
    variant="info"
    size="sm"
  )
</template>

<script>
import SubmitButton from "@/library/SubmitButton.vue";

export default {
  components: {
    SubmitButton
  },
  props: {
    mode: {
      type: String,
      default: ""
    },
    date: {
      type: Object,
      default: ""
    },
    tbl: {
      type: String,
      default: ""
    },
    btnTxt: {
      type: String,
      default: "export_excel"
    },
  },
  data(){
    return{
      loading: false,
      uri :'data:application/vnd.ms-excel;base64,',
      template:'<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function(s){ return window.btoa(unescape(encodeURIComponent(s))) },
      format: function(s, c) { return s.replace(/{(\w+)}/g, function(m, p) { return c[p]; }) }
    }
  },
  methods: {
    tableToExcel(){
      var table = this.tbl;
      this.loading = true;
      if (!table.nodeType) table = document.getElementById(table)
      var worksheetTitle = this.$moment(this.date.startDate).format("YYYYMMDD") + "-" + this.$moment(this.date.endDate).format("YYYYMMDD")
      var ctx = {worksheet: worksheetTitle || 'Worksheet', table: table.innerHTML}
      // window.location.href = this.uri + this.base64(this.format(this.template, ctx))
      var link = document.createElement("a")
      link.download = this.mode + "-" + this.$store.getters.accountId.toUpperCase() + "-" +  worksheetTitle +  ".xls"
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
      this.loading = false;
    }
  }
};
</script>